/*
 * Copyright (c) 2020. Sayari LLC
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './login/login.component';
import {AdminComponent} from './admin/admin.component';
import {SpecialsComponent} from './specials/specials.component';

const routes: Routes = [{path: '', redirectTo: '/specials', pathMatch: 'full'}, {path: 'login', component: LoginComponent},
    {path: 'admin', component: AdminComponent}, {path: 'specials', component: SpecialsComponent}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
